import { connect } from 'react-redux';
import {
  fetchRecentlyViewedSpaces,
  toggleStarSpace,
} from '@core/spaceSelector/operations';
import { getCurrentUser } from '@core/utils/currentUser';
import { getCurrentSpace } from '@core/selectors/space';
import { isInstructor } from '@core/selectors/classroom';
import { RecentlyViewedSpaces } from './RecentlyViewedSpaces';

const mapStateToProps = (state) => {
  const user = getCurrentUser();
  return {
    recentlyViewedSpaceList:
      state?.spaceSelector?.recentlyViewedSpaces?.spaceList,
    user,
    space: getCurrentSpace(state),
    isEducator: isInstructor(state, user?.objectId) || false,
    isStaff: user?.userRoles?.includes('staff') || false,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onfetchRecentlyViewedSpaces: () => dispatch(fetchRecentlyViewedSpaces()),
    onSpaceStar: async ({
      spaceId,
      showArchived,
      sort,
      search,
      category,
      subCategory,
    }) => {
      await dispatch(
        toggleStarSpace({
          spaceId,
          search,
          sort,
          showArchived,
          category,
          subCategory,
        })
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentlyViewedSpaces);
